import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installConsoleBuffer } from "./lib/console-buffer";
import { installChunkErrorRecovery } from "./lib/chunk-reload";

installConsoleBuffer();
installChunkErrorRecovery();

createRoot(document.getElementById("root")!).render(<App />);

// The recovery budget is deliberately NOT cleared after a successful mount:
// it expires on its own time window instead, so a flaky or offline connection
// cannot bounce the user through repeated full-page reloads.

